import React, { useCallback } from "react";
import client from "@culturehq/client";
import { Icon, Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { useFetch } from "app/hooks";
import { Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";

import SuggestedInterest from "./SuggestedInterest";

const SuggestedInterests = ({ isFeed = false }) => {
  const { profile } = useProfile();

  const { fetching, error, json, onUpdate } = useFetch(client.listProfileSuggestedInterests);
  const { interests = [] } = json;

  const onInterestAdded = useCallback(
    interest => onUpdate(state => ({
      interests: state.interests.map(current => (
        current.name === interest.name
          ? ({ ...current, userCount: current.userCount + 1 })
          : current
      ))
    })),
    [onUpdate]
  );

  if (fetching || error || interests.length === 0) {
    return null;
  }

  return (
    <Panel className="SidePanel">
      <Panel.Heading>
        <Icon icon="heart-ol" />
        {" "}
        <Trans>Suggested Interests</Trans>
      </Panel.Heading>
      <Panel.LoaderBody loading={fetching}>
        <ErrorBoundary>
          {interests.map(interest => (
            <SuggestedInterest
              key={interest.name}
              interest={interest}
              interests={profile.interests}
              isFeed={isFeed}
              onInterestAdded={onInterestAdded}
            />
          ))}
        </ErrorBoundary>
      </Panel.LoaderBody>
    </Panel>
  );
};

export default SuggestedInterests;
